module.exports = __webpack_public_path__ + "img/guonei0.be824661.png";